import React from 'react';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import PinIcon from '@atlaskit/icon/core/pin';
import PinFilledIcon from '@atlaskit/icon/core/pin-filled';
export var getPinOptionToolbarConfig = function getPinOptionToolbarConfig(_ref) {
  var _api$connectivity;
  var api = _ref.api,
    toolbarDocking = _ref.toolbarDocking,
    intl = _ref.intl;
  var isOffline = (api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) === 'offline';
  var pinButton = {
    disabled: isOffline,
    id: 'editor.toolbar.unpined',
    icon: function icon() {
      return /*#__PURE__*/React.createElement(PinIcon, {
        label: ""
      });
    },
    onClick: function onClick() {
      var _api$selectionToolbar, _api$selectionToolbar2, _api$selectionToolbar3;
      return (_api$selectionToolbar = api === null || api === void 0 || (_api$selectionToolbar2 = api.selectionToolbar.actions) === null || _api$selectionToolbar2 === void 0 || (_api$selectionToolbar3 = _api$selectionToolbar2.setToolbarDocking) === null || _api$selectionToolbar3 === void 0 ? void 0 : _api$selectionToolbar3.call(_api$selectionToolbar2, 'top')) !== null && _api$selectionToolbar !== void 0 ? _api$selectionToolbar : false;
    },
    title: intl.formatMessage(selectionToolbarMessages.toolbarPositionUnpined),
    type: 'button'
  };
  var isDockedToTop = toolbarDocking === 'top';
  if (isDockedToTop) {
    pinButton = {
      disabled: isOffline,
      id: 'editor.toolbar.pinedToTop',
      icon: function icon() {
        return /*#__PURE__*/React.createElement(PinFilledIcon, {
          label: ""
        });
      },
      onClick: function onClick() {
        var _api$selectionToolbar4, _api$selectionToolbar5, _api$selectionToolbar6;
        return (_api$selectionToolbar4 = api === null || api === void 0 || (_api$selectionToolbar5 = api.selectionToolbar.actions) === null || _api$selectionToolbar5 === void 0 || (_api$selectionToolbar6 = _api$selectionToolbar5.setToolbarDocking) === null || _api$selectionToolbar6 === void 0 ? void 0 : _api$selectionToolbar6.call(_api$selectionToolbar5, 'none')) !== null && _api$selectionToolbar4 !== void 0 ? _api$selectionToolbar4 : false;
      },
      type: 'button',
      title: intl.formatMessage(selectionToolbarMessages.toolbarPositionPinedAtTop)
    };
  }
  return [{
    type: 'separator',
    fullHeight: true
  }, pinButton];
};